import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridBoleto = ({ codigoFamilia, boletos, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [quadraOptions, setQuadraOptions] = useState([]);
  const [loteOptions, setLoteOptions] = useState([]);
  const [quadraSel, setQuadraSel] = useState(null);
  const [loteSel, setLoteSel] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!showForm) return;
    api.listarQuadrasConfig(codigoFamilia)
      .then((res) => {
        const lista = res && res.data ? res.data : (res || []);
        const opts = (Array.isArray(lista) ? lista : []).map((q) => ({
          value: q.codigo,
          label: q.descricao,
        }));
        setQuadraOptions(opts);
      })
      .catch(() => {});
  }, [showForm, codigoFamilia]);

  useEffect(() => {
    if (quadraSel == null) {
      setLoteOptions([]);
      return;
    }
    api.listarLotesConfig(codigoFamilia, quadraSel.value)
      .then((res) => {
        const lista = res && res.data ? res.data : (res || []);
        const opts = (Array.isArray(lista) ? lista : []).map((l) => ({
          value: l.codigo,
          label: l.descricao,
        }));
        setLoteOptions(opts);
      })
      .catch(() => {});
  }, [quadraSel, codigoFamilia]);

  const handleAbrirForm = () => {
    setQuadraSel(null);
    setLoteSel(null);
    setShowForm(true);
  };

  const handleIncluir = async () => {
    if (quadraSel == null || loteSel == null) {
      toast.warn('Selecione quadra e lote.');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirBoletoGraficaConfig({
        codigo_familia: codigoFamilia,
        quadra: quadraSel.value,
        lote: loteSel.value,
      });
      toast.success('Boleto gráfica incluído com sucesso!');
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir boleto gráfica';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir boleto gráfica do imóvel Qd ' + item.qd + ' Lt ' + item.lt + '?')) return;
    try {
      await api.excluirBoletoGraficaConfig({
        codigo_ativo: item.codigo_ativo,
      });
      toast.success('Boleto gráfica excluído!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir boleto gráfica';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Imóveis Boleto Gráfica</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Quadra</Form.Label>
                  <Select
                    options={quadraOptions}
                    value={quadraSel}
                    onChange={(opt) => { setQuadraSel(opt); setLoteSel(null); }}
                    placeholder="Selecione quadra..."
                    isClearable
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small mb-1">Lote</Form.Label>
                  <Select
                    options={loteOptions}
                    value={loteSel}
                    onChange={setLoteSel}
                    placeholder="Selecione lote..."
                    isClearable
                    isDisabled={quadraSel == null}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Quadra</th>
              <th>Lote</th>
              <th>Status</th>
              <th>Dt. Inclusão</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {boletos.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center text-muted">
                  Nenhum boleto gráfica cadastrado
                </td>
              </tr>
            )}
            {boletos.map((item) => (
              <tr key={item.codigo_ativo}>
                <td>{item.qd}</td>
                <td>{item.lt}</td>
                <td>{item.st}</td>
                <td>{item.data_inclusao}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridBoleto;
